import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Pagination } from "@/components/molecules/Pagination";
import { PaginationType } from "@/models/common";
import { TableContainer, TableSortLabel } from "@mui/material";
import { PartnerUsersConstants } from "./PartnerUsersConstants";
import {
  PartnerUser,
  PartnerUsersOrder,
  PartnerUsersSortKey,
} from "@/models/partnerUsers";
import { AuthButton } from "@/components/molecules/AuthButton.";
import { CommonConstants } from "@/common/CommonConstants";
import { DisplayName, GX_ADMIN } from "@/models/auth";

export type UserRoleListProps = {
  onChangePage: (page: number) => void;
  pagingData: PaginationType;
  partnerUsers: PartnerUser[];
  orderTypes: PartnerUsersOrder;
  ownerUserId?: number;
  onClickChangeSort: (key: PartnerUsersSortKey) => void;
  onClickEdit: (id: number) => void;
};

export const UserRoleList = (props: UserRoleListProps) => {
  const {
    onChangePage,
    partnerUsers,
    pagingData,
    orderTypes,
    ownerUserId,
    onClickChangeSort,
    onClickEdit,
  } = props;

  return (
    <React.Fragment>
      <TableContainer className="table-container-width">
        <Table size="small">
          <TableHead className="list-head">
            <TableRow>
              <TableCell className="table-cell-width-custom">
                {PartnerUsersConstants.PartnerUserName}
                <TableSortLabel
                  active={partnerUsers.length > 0 && !!orderTypes.name}
                  direction={orderTypes.name === "desc" ? "desc" : "asc"}
                  sx={{ ":hover": { color: "red" } }}
                  onClick={() => onClickChangeSort("name")}
                />
              </TableCell>
              <TableCell>
                {PartnerUsersConstants.UserRole}
                <TableSortLabel
                  active={partnerUsers.length > 0 && !!orderTypes.partner_role_id}
                  direction={
                    orderTypes.partner_role_id === "desc" ? "desc" : "asc"
                  }
                  sx={{ ":hover": { color: "red" } }}
                  onClick={() => onClickChangeSort("partner_role_id")}
                />
              </TableCell>
              <TableCell>{PartnerUsersConstants.OfficeCount}</TableCell>
              <TableCell>{PartnerUsersConstants.AvailableOffices}</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={{ wordBreak: "break-all" }}>
            {partnerUsers.map((row) => (
              <TableRow key={row.id} hover>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.partnerRoles?.name}</TableCell>
                <TableCell>
                  {row.partnerRoleId === GX_ADMIN
                    ? PartnerUsersConstants.Hyphen
                    : row.officeCount ?? "0"}
                </TableCell>
                <TableCell>
                  {row.partnerRoleId === GX_ADMIN
                    ? PartnerUsersConstants.Hyphen
                    : row.office?.displayName ?? ""}
                </TableCell>
                <TableCell sx={{ textAlign: "right", pr: 0 }}>
                  <AuthButton
                    label={CommonConstants.Edit}
                    name={DisplayName.PartnerUserEdit}
                    onClick={() => onClickEdit(row.id || 0)}
                    sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                    disabled={row.id === ownerUserId}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        total={pagingData.total}
        page={pagingData.page}
        size={pagingData.size || 30}
        setPage={onChangePage}
      />
    </React.Fragment>
  );
};
